import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AppProviders } from './context';

import App from './App';

import { initColors } from './styles/initColors';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
initColors();
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AppProviders>
      <App />
    </AppProviders>
  </BrowserRouter>
  // </React.StrictMode>
);
